import PubSub from "underpub-js";

var ContentTextTypeFour = function(options) {

	this.options = {
		$el: false,
		baseClass: 'mol-ContentTextTypeFour',
	};

	$.extend(true, this.options, options);

};

ContentTextTypeFour.prototype.init = function() {

	var self = this;

};

export default ContentTextTypeFour;
